// Fase 5 — ISO 3166-1 alpha-2 country list with NL + EN display names.
// Canonical stored value = uppercase ISO code. Backend `catalog.py` mirrors
// this set. Sorting happens at render time (by localised name).
export const COUNTRIES = [
  ["AD","Andorra","Andorra"],["AE","Verenigde Arabische Emiraten","United Arab Emirates"],
  ["AF","Afghanistan","Afghanistan"],["AG","Antigua en Barbuda","Antigua and Barbuda"],
  ["AI","Anguilla","Anguilla"],["AL","Albanië","Albania"],["AM","Armenië","Armenia"],
  ["AO","Angola","Angola"],["AQ","Antarctica","Antarctica"],["AR","Argentinië","Argentina"],
  ["AS","Amerikaans-Samoa","American Samoa"],["AT","Oostenrijk","Austria"],
  ["AU","Australië","Australia"],["AW","Aruba","Aruba"],["AX","Ålandseilanden","Åland Islands"],
  ["AZ","Azerbeidzjan","Azerbaijan"],["BA","Bosnië en Herzegovina","Bosnia and Herzegovina"],
  ["BB","Barbados","Barbados"],["BD","Bangladesh","Bangladesh"],["BE","België","Belgium"],
  ["BF","Burkina Faso","Burkina Faso"],["BG","Bulgarije","Bulgaria"],["BH","Bahrein","Bahrain"],
  ["BI","Burundi","Burundi"],["BJ","Benin","Benin"],["BL","Saint-Barthélemy","Saint Barthélemy"],
  ["BM","Bermuda","Bermuda"],["BN","Brunei","Brunei"],["BO","Bolivia","Bolivia"],
  ["BQ","Caribisch Nederland","Caribbean Netherlands"],["BR","Brazilië","Brazil"],
  ["BS","Bahama's","Bahamas"],["BT","Bhutan","Bhutan"],["BV","Bouveteiland","Bouvet Island"],
  ["BW","Botswana","Botswana"],["BY","Wit-Rusland","Belarus"],["BZ","Belize","Belize"],
  ["CA","Canada","Canada"],["CC","Cocoseilanden","Cocos (Keeling) Islands"],
  ["CD","Congo-Kinshasa","DR Congo"],["CF","Centraal-Afrikaanse Republiek","Central African Republic"],
  ["CG","Congo-Brazzaville","Congo"],["CH","Zwitserland","Switzerland"],["CI","Ivoorkust","Côte d'Ivoire"],
  ["CK","Cookeilanden","Cook Islands"],["CL","Chili","Chile"],["CM","Kameroen","Cameroon"],
  ["CN","China","China"],["CO","Colombia","Colombia"],["CR","Costa Rica","Costa Rica"],
  ["CU","Cuba","Cuba"],["CV","Kaapverdië","Cape Verde"],["CW","Curaçao","Curaçao"],
  ["CX","Christmaseiland","Christmas Island"],["CY","Cyprus","Cyprus"],["CZ","Tsjechië","Czechia"],
  ["DE","Duitsland","Germany"],["DJ","Djibouti","Djibouti"],["DK","Denemarken","Denmark"],
  ["DM","Dominica","Dominica"],["DO","Dominicaanse Republiek","Dominican Republic"],
  ["DZ","Algerije","Algeria"],["EC","Ecuador","Ecuador"],["EE","Estland","Estonia"],
  ["EG","Egypte","Egypt"],["EH","Westelijke Sahara","Western Sahara"],["ER","Eritrea","Eritrea"],
  ["ES","Spanje","Spain"],["ET","Ethiopië","Ethiopia"],["FI","Finland","Finland"],
  ["FJ","Fiji","Fiji"],["FK","Falklandeilanden","Falkland Islands"],
  ["FM","Micronesië","Micronesia"],["FO","Faeröer","Faroe Islands"],["FR","Frankrijk","France"],
  ["GA","Gabon","Gabon"],["GB","Verenigd Koninkrijk","United Kingdom"],["GD","Grenada","Grenada"],
  ["GE","Georgië","Georgia"],["GF","Frans-Guyana","French Guiana"],["GG","Guernsey","Guernsey"],
  ["GH","Ghana","Ghana"],["GI","Gibraltar","Gibraltar"],["GL","Groenland","Greenland"],
  ["GM","Gambia","Gambia"],["GN","Guinee","Guinea"],["GP","Guadeloupe","Guadeloupe"],
  ["GQ","Equatoriaal-Guinea","Equatorial Guinea"],["GR","Griekenland","Greece"],
  ["GS","Zuid-Georgia","South Georgia"],["GT","Guatemala","Guatemala"],["GU","Guam","Guam"],
  ["GW","Guinee-Bissau","Guinea-Bissau"],["GY","Guyana","Guyana"],["HK","Hongkong","Hong Kong"],
  ["HM","Heard en McDonaldeilanden","Heard & McDonald Islands"],["HN","Honduras","Honduras"],
  ["HR","Kroatië","Croatia"],["HT","Haïti","Haiti"],["HU","Hongarije","Hungary"],
  ["ID","Indonesië","Indonesia"],["IE","Ierland","Ireland"],["IL","Israël","Israel"],
  ["IM","Isle of Man","Isle of Man"],["IN","India","India"],
  ["IO","Brits Indische Oceaanterritorium","British Indian Ocean Territory"],
  ["IQ","Irak","Iraq"],["IR","Iran","Iran"],["IS","IJsland","Iceland"],["IT","Italië","Italy"],
  ["JE","Jersey","Jersey"],["JM","Jamaica","Jamaica"],["JO","Jordanië","Jordan"],
  ["JP","Japan","Japan"],["KE","Kenia","Kenya"],["KG","Kirgizië","Kyrgyzstan"],
  ["KH","Cambodja","Cambodia"],["KI","Kiribati","Kiribati"],["KM","Comoren","Comoros"],
  ["KN","Saint Kitts en Nevis","Saint Kitts and Nevis"],["KP","Noord-Korea","North Korea"],
  ["KR","Zuid-Korea","South Korea"],["KW","Koeweit","Kuwait"],["KY","Kaaimaneilanden","Cayman Islands"],
  ["KZ","Kazachstan","Kazakhstan"],["LA","Laos","Laos"],["LB","Libanon","Lebanon"],
  ["LC","Saint Lucia","Saint Lucia"],["LI","Liechtenstein","Liechtenstein"],
  ["LK","Sri Lanka","Sri Lanka"],["LR","Liberia","Liberia"],["LS","Lesotho","Lesotho"],
  ["LT","Litouwen","Lithuania"],["LU","Luxemburg","Luxembourg"],["LV","Letland","Latvia"],
  ["LY","Libië","Libya"],["MA","Marokko","Morocco"],["MC","Monaco","Monaco"],
  ["MD","Moldavië","Moldova"],["ME","Montenegro","Montenegro"],["MF","Sint-Maarten (Frans)","Saint Martin"],
  ["MG","Madagaskar","Madagascar"],["MH","Marshalleilanden","Marshall Islands"],
  ["MK","Noord-Macedonië","North Macedonia"],["ML","Mali","Mali"],["MM","Myanmar","Myanmar"],
  ["MN","Mongolië","Mongolia"],["MO","Macau","Macao"],["MP","Noordelijke Marianen","Northern Mariana Islands"],
  ["MQ","Martinique","Martinique"],["MR","Mauritanië","Mauritania"],["MS","Montserrat","Montserrat"],
  ["MT","Malta","Malta"],["MU","Mauritius","Mauritius"],["MV","Maldiven","Maldives"],
  ["MW","Malawi","Malawi"],["MX","Mexico","Mexico"],["MY","Maleisië","Malaysia"],
  ["MZ","Mozambique","Mozambique"],["NA","Namibië","Namibia"],["NC","Nieuw-Caledonië","New Caledonia"],
  ["NE","Niger","Niger"],["NF","Norfolkeiland","Norfolk Island"],["NG","Nigeria","Nigeria"],
  ["NI","Nicaragua","Nicaragua"],["NL","Nederland","Netherlands"],["NO","Noorwegen","Norway"],
  ["NP","Nepal","Nepal"],["NR","Nauru","Nauru"],["NU","Niue","Niue"],["NZ","Nieuw-Zeeland","New Zealand"],
  ["OM","Oman","Oman"],["PA","Panama","Panama"],["PE","Peru","Peru"],["PF","Frans-Polynesië","French Polynesia"],
  ["PG","Papoea-Nieuw-Guinea","Papua New Guinea"],["PH","Filipijnen","Philippines"],
  ["PK","Pakistan","Pakistan"],["PL","Polen","Poland"],["PM","Saint-Pierre en Miquelon","Saint Pierre and Miquelon"],
  ["PN","Pitcairneilanden","Pitcairn Islands"],["PR","Puerto Rico","Puerto Rico"],
  ["PS","Palestina","Palestine"],["PT","Portugal","Portugal"],["PW","Palau","Palau"],
  ["PY","Paraguay","Paraguay"],["QA","Qatar","Qatar"],["RE","Réunion","Réunion"],
  ["RO","Roemenië","Romania"],["RS","Servië","Serbia"],["RU","Rusland","Russia"],
  ["RW","Rwanda","Rwanda"],["SA","Saoedi-Arabië","Saudi Arabia"],["SB","Salomonseilanden","Solomon Islands"],
  ["SC","Seychellen","Seychelles"],["SD","Soedan","Sudan"],["SE","Zweden","Sweden"],
  ["SG","Singapore","Singapore"],["SH","Sint-Helena","Saint Helena"],["SI","Slovenië","Slovenia"],
  ["SJ","Spitsbergen en Jan Mayen","Svalbard and Jan Mayen"],["SK","Slowakije","Slovakia"],
  ["SL","Sierra Leone","Sierra Leone"],["SM","San Marino","San Marino"],["SN","Senegal","Senegal"],
  ["SO","Somalië","Somalia"],["SR","Suriname","Suriname"],["SS","Zuid-Soedan","South Sudan"],
  ["ST","Sao Tomé en Principe","São Tomé and Príncipe"],["SV","El Salvador","El Salvador"],
  ["SX","Sint-Maarten","Sint Maarten"],["SY","Syrië","Syria"],["SZ","Eswatini","Eswatini"],
  ["TC","Turks- en Caicoseilanden","Turks and Caicos Islands"],["TD","Tsjaad","Chad"],
  ["TF","Franse Zuidelijke Gebieden","French Southern Territories"],["TG","Togo","Togo"],
  ["TH","Thailand","Thailand"],["TJ","Tadzjikistan","Tajikistan"],["TK","Tokelau","Tokelau"],
  ["TL","Oost-Timor","Timor-Leste"],["TM","Turkmenistan","Turkmenistan"],
  ["TN","Tunesië","Tunisia"],["TO","Tonga","Tonga"],["TR","Turkije","Türkiye"],
  ["TT","Trinidad en Tobago","Trinidad and Tobago"],["TV","Tuvalu","Tuvalu"],
  ["TW","Taiwan","Taiwan"],["TZ","Tanzania","Tanzania"],["UA","Oekraïne","Ukraine"],
  ["UG","Oeganda","Uganda"],["UM","VS-Ultraperifere eilanden","U.S. Minor Outlying Islands"],
  ["US","Verenigde Staten","United States"],["UY","Uruguay","Uruguay"],["UZ","Oezbekistan","Uzbekistan"],
  ["VA","Vaticaanstad","Vatican City"],["VC","Saint Vincent en de Grenadines","Saint Vincent and the Grenadines"],
  ["VE","Venezuela","Venezuela"],["VG","Britse Maagdeneilanden","British Virgin Islands"],
  ["VI","Amerikaanse Maagdeneilanden","U.S. Virgin Islands"],["VN","Vietnam","Vietnam"],
  ["VU","Vanuatu","Vanuatu"],["WF","Wallis en Futuna","Wallis and Futuna"],
  ["WS","Samoa","Samoa"],["YE","Jemen","Yemen"],["YT","Mayotte","Mayotte"],
  ["ZA","Zuid-Afrika","South Africa"],["ZM","Zambia","Zambia"],["ZW","Zimbabwe","Zimbabwe"],
];

export function countryLabel(code, lang) {
  if (!code) return "";
  const hit = COUNTRIES.find((c) => c[0] === String(code).toUpperCase());
  if (!hit) return code;
  return lang === "nl" ? hit[1] : hit[2];
}

// Timezone catalog is not shipped statically — the browser has
// Intl.supportedValuesOf('timeZone') on evergreen engines, which returns the
// IANA set the same way Python's zoneinfo does on the server. We keep a small
// curated fallback for headless test envs.
export const TIMEZONE_FALLBACK = [
  "UTC","Europe/Amsterdam","Europe/Brussels","Europe/London","Europe/Paris",
  "Europe/Berlin","Europe/Madrid","Europe/Rome","Europe/Warsaw","Europe/Stockholm",
  "Europe/Athens","Europe/Istanbul","Europe/Moscow","Africa/Cairo","Africa/Johannesburg",
  "Asia/Dubai","Asia/Karachi","Asia/Kolkata","Asia/Bangkok","Asia/Singapore",
  "Asia/Hong_Kong","Asia/Tokyo","Asia/Seoul","Australia/Sydney","Pacific/Auckland",
  "America/New_York","America/Chicago","America/Denver","America/Los_Angeles",
  "America/Sao_Paulo","America/Toronto",
];

export function listTimezones() {
  let arr;
  try {
    const fn = Intl.supportedValuesOf;
    if (typeof fn === "function") arr = fn.call(Intl, "timeZone");
  } catch { /* fall through */ }
  if (!arr || arr.length === 0) arr = TIMEZONE_FALLBACK;
  // Intl.supportedValuesOf never emits "UTC" — add it so the picker always has it.
  return arr.includes("UTC") ? arr : ["UTC", ...arr];
}

// Small readability helper — "Europe/Amsterdam" -> "Amsterdam · Europe".
export function tzLabel(tz) {
  if (!tz) return "";
  const parts = tz.split("/");
  if (parts.length === 1) return tz;
  const city = parts[parts.length - 1].replace(/_/g, " ");
  return `${city} · ${parts[0].replace(/_/g, " ")}`;
}
